import React from 'react';
import { FormGroup } from '@tencent/spaui';

const MyTextArea = (props) => {
  const { value = '', disabled = false } = props;

  let maxLength = 0;
  if (props.maxLen != undefined) {
    maxLength = props.maxLen;
  } else if (props.maxLength != undefined) {
    maxLength = props.maxLength;
  }

  let valueLength = 0;
  for (let i = 0; i < value.length; i++) {
    const length = value.charCodeAt(i);
    if (length >= 0 && length <= 128) {
      valueLength += 1;
    } else {
      valueLength += 2;
    }
  }

  return (
    <FormGroup
      status={props.status}
      feedback={
        <span>
          <span className="spaui-input-feedback-count">{valueLength}</span>
          <span className="spaui-input-feedback-divider">/</span>
          <span className="spaui-input-feedback-range">{maxLength}</span>
        </span>
      }
    >
      <textarea className="spaui-input" {...props} disabled={disabled}>
        {value}
      </textarea>
    </FormGroup>
  );
};

export default MyTextArea;
